export interface IFilter {
  name: string;
  value: string;
}
